import { render, staticRenderFns } from "./TradingPairInformation.vue?vue&type=template&id=72f7000b&scoped=true"
import script from "./TradingPairInformation.vue?vue&type=script&lang=js"
export * from "./TradingPairInformation.vue?vue&type=script&lang=js"
import style0 from "./TradingPairInformation.vue?vue&type=style&index=0&id=72f7000b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7000b",
  null
  
)

export default component.exports